// @ts-ignore
import packageInfo from '../../package.json';
export const environment = {
  production: false,
  apiUrl: 'https://api-vendor-test.aclarian.com/api/',
  baseUrl: 'https://vendor2-test.aclarian.com',
  appName: 'Sample City  | VendorV2',
  tokenizationKey: 'PaQmTu-VE6uUF-9V6acY-jecjXr',
  datadogClientToken: 'pubdb2de49414c0e0a5b6e6cb0befc8d0b2',
  datadogApplicationId: '2cc480e9-5ba3-4a3b-aa2e-2768983ad967',
  datadogService: 'invoicing_samplecity_test',
  ApiKey: 'Xg7#pQvL2@MZt9F%',
  env: 'test',
  version: packageInfo.version,
};
